import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import storeHelper from '@/store/helper'
import fileDownload from 'js-file-download'
import moment from 'moment/moment'
export class GPDKKDService extends BaseService {
  static async fetchAfs(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.list-sticker-image'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async fetchSale(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldr.list-sticker-images'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getAfs(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.sticker-image-detail'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getSale(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldr.get-sticker-image-detail'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async saleApprove(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldr.approve'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async approve(customerId) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.mc-sticker-image-auto-complete'),
        { customerId }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async saleReject(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldr.reject'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async afsApprove(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.sticker-image-approve'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async afsReject(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.sticker-image-reject'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getFileFromS3(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.file-get'),
        params,
        {
          responseType: 'blob',
        }
      )
      return response.data
    } catch (error) {}
  }

  static async verifyGPDKKD(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.mc-check-sticker-image-update'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async detailMerchant(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.mc-sticker-image-detail'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async uploadFileMerchant(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.mc-sticker-image-upload'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateUrl(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.mc-sticker-image-update'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async bsGPLater(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.mc-sticker-wait'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportExcelSale(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldr.export-excel-wkcldr-sticker-image'),
        params,
        {
          responseType: 'blob',
        }
      )

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      fileDownload(
        response.data,
        'Export_CongviecSale' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportExcelAfs(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.export-sticker-image'),
        params,
        {
          responseType: 'blob',
        }
      )

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      fileDownload(
        response.data,
        'Export_CongviecAfs' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async resetLink(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.sticker-image-rollback'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListDKKDstate() {
    try {
      const response = await this.request({ auth: true }).get(
        storeHelper.getUrl('cnps.cstm.dkkd-change-state')
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async businessChangeCareState(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.business-change-care-state'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
